import apiUser from "../../apiUser";
import dataLayerPush from "utils/dataLayerPush";
import {setWorkshop} from "../workshop/actions";
import {setVats} from "../vats/actions";
export const SET = 'user/SET';

export function setUser(value) {
  if(value){
    dataLayerPush({
      event: 'logged',
      loggedUserType: 'user',
    })
  }

  return {
    type: SET,
    value
  }
}

export function welcomeModalUpdate(data){
  return dispatch => {
    return apiUser.welcomeModal(data)
        .then(res => {
          if(res.data.user) {
            dispatch(setUser(res.data.user));
          }
          if(res.data.workshop) {
            dispatch(setWorkshop(res.data.workshop));
          }
          if(res.data.vats) {
            dispatch(setVats(res.data.vats));
          }
          return res;
        })
  };
}

export function acceptRegulations(){
  return dispatch => {
    return apiUser.user.acceptRegulations()
      .then(res => dispatch(setUser(res.user)))
  }
}

export function acceptBrowserPluginRegulations(){
  return dispatch => {
    return apiUser.user.acceptBrowserPluginRegulations()
      .then(res => dispatch(setUser(res.user)))
  }
}